import { addProtocol } from '../../../../utils/addProtocol';
import { IconNewTab } from '../../../icon/IconNewTab';
import { Button } from '../../../input/Button';
import { ClickOutButtonProps } from '../types';

export const ClickOutButton = ({ url, text, onClick, ...other }: ClickOutButtonProps) => (
    <Button
        flexGrow={1}
        as="a"
        href={addProtocol(url)}
        target="_blank"
        size="m"
        rel="nofollow noreferrer"
        variant="filled"
        color="secondary"
        spacing={1}
        onClick={onClick}
        {...other}
    >
        {text}
        <IconNewTab fontSize={20} color="inherit" />
    </Button>
);
